const EMPTY = '--';

const formatRatingValue = score => {
  if (!score) return EMPTY;
  const fixedScore = parseFloat(score).toFixed(1);
  return fixedScore === 'NaN' ? EMPTY : fixedScore;
};

export default formatRatingValue;
